export const formatBps = (value) => {
  const num = Number(value || 0);
  if (!Number.isFinite(num) || num <= 0) return '0 bps';
  if (num >= 1_000_000_000) return `${(num / 1_000_000_000).toFixed(2)} Gbps`;
  if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(2)} Mbps`;
  if (num >= 1_000) return `${(num / 1_000).toFixed(2)} Kbps`;
  return `${num.toFixed(0)} bps`;
};

export const formatNumber = (value) => {
  const num = Number(value || 0);
  if (!Number.isFinite(num)) return '0';
  return new Intl.NumberFormat('id-ID').format(num);
};

export const formatTime = (value) => {
  if (!value) return '-';
  try {
    return new Date(value).toLocaleString('id-ID');
  } catch {
    return String(value);
  }
};

export const normalizeHistorySeries = (samples = []) => {
  if (!Array.isArray(samples)) return [];
  return [...samples]
    .slice()
    .reverse()
    .map((item) => ({
      timestamp: item.timestamp || item.sampled_at || item.time,
      label: item.timestamp ? new Date(item.timestamp).toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' }) : '-',
      in_bps: Number(item.in_bps || 0),
      out_bps: Number(item.out_bps || 0),
    }));
};

